export const ErrorPagesConfig = {
  pageNotFound: 'https://app.audiense.com/page-not-found?product=soprism',
  accessDenied: 'https://app.audiense.com/access-denied?product=soprism'
};
